import { comics, rankingIds } from "@/mocks/comics";
import SectionHeader from "@/components/feature/SectionHeader";
import { Link } from "react-router-dom";

function Ranking() {
  const list = rankingIds
    .map((id) => comics.find((c) => c.id === id))
    .filter((c): c is NonNullable<typeof c> => Boolean(c))
    .slice(0, 8);

  return (
    <section className="mx-auto max-w-7xl px-4 md:px-6 py-16 md:py-24">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-5">
        <div className="lg:col-span-2">
          <SectionHeader
            eyebrow="Trending Now"
            title="本周热榜"
            desc="实时更新的热门排行榜，由千万读者的追更数据精算而来，绝不缺席每一部爆款神作。"
          />
          <div className="mt-8 rounded-lg border border-primary-500/20 bg-gradient-to-br from-primary-500/10 to-transparent p-6">
            <div className="flex items-center gap-4">
              <span className="flex h-14 w-14 items-center justify-center rounded-full bg-gradient-to-br from-primary-500 to-accent-500 text-2xl text-foreground-950">
                <i className="ri-fire-fill"></i>
              </span>
              <div>
                <p className="font-heading text-2xl font-bold text-gold-grad">{list[0]?.title}</p>
                <p className="mt-1 text-sm text-foreground-400">本周热度 {list[0]?.hotScore} · {list[0]?.views}阅读</p>
              </div>
            </div>
            <p className="mt-4 text-sm leading-7 text-foreground-300">{list[0]?.description}</p>
            <Link
              to={list[0] ? `/comic/${list[0].id}` : "/category"}
              className="mt-5 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-gradient-to-r from-primary-500 to-accent-500 px-5 py-2.5 text-sm font-semibold text-foreground-950 transition hover:from-primary-400 hover:to-accent-400 cursor-pointer"
            >
              <i className="ri-book-open-fill"></i>
              立即追更
            </Link>
          </div>
        </div>

        <div className="lg:col-span-3">
          <ol className="space-y-3">
            {list.map((comic, idx) => {
              const rankColor =
                idx === 0
                  ? "from-accent-400 to-primary-600"
                  : idx === 1
                    ? "from-secondary-400 to-primary-600"
                    : idx === 2
                      ? "from-primary-600 to-secondary-500"
                      : "from-background-700 to-background-800";
              return (
                <li key={comic.id}>
                  <Link
                    to={`/comic/${comic.id}`}
                    className="flex items-center gap-4 rounded-lg border border-background-800 bg-background-900/70 p-3 transition hover:border-primary-500/40 hover:bg-background-900"
                  >
                    <span
                      className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-gradient-to-br ${rankColor} font-heading text-sm font-bold text-foreground-950`}
                    >
                      {idx + 1}
                    </span>
                    <img
                      src={comic.cover}
                      alt={`${comic.title}漫画封面`}
                      className="h-16 w-12 shrink-0 rounded object-cover object-top"
                    />
                    <div className="min-w-0 flex-1">
                      <h3 className="truncate font-heading text-sm font-semibold text-foreground-100 md:text-base">
                        {comic.title}
                      </h3>
                      <p className="mt-1 flex items-center gap-3 text-xs text-foreground-500">
                        <span>{comic.category}</span>
                        <span>{comic.status}</span>
                        <span>{comic.chapters}话</span>
                      </p>
                    </div>
                    <div className="hidden shrink-0 flex-col items-end sm:flex">
                      <span className="flex items-center gap-1 text-sm font-semibold text-primary-400">
                        <i className="ri-fire-fill text-xs"></i>
                        {comic.hotScore}
                      </span>
                      <span className="mt-1 text-xs text-foreground-500">{comic.views}</span>
                    </div>
                  </Link>
                </li>
              );
            })}
          </ol>
        </div>
      </div>
    </section>
  );
}

export default Ranking;